import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Typography,
  TextField,
  Button,
  Snackbar,
  CircularProgress,
} from "@material-ui/core";
import { passwordStrength } from "check-password-strength";
import { Alert } from "@material-ui/lab";
import { signup } from "../../api-interactions/authentication";

export const SignupAccount = (props) => {
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // const signInWithGoogle = () => {
  // };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    const pwStrength = passwordStrength(passwordRef.current.value, [
      { id: 2, value: "Medium", minDiversity: 3, minLength: 8 },
    ]);

    console.log(pwStrength);

    if (pwStrength.value !== "Strong" && pwStrength.value !== "Medium") {
      return setError("Password isn't strong enough");
    }

    setError("");
    setLoading(true);

    const err = await signup({
      firstName: "New",
      lastName: "user",
      email: emailRef.current.value,
      password: passwordRef.current.value,
      passwordConfirm: passwordConfirmRef.current.value,
    });
    if (err === undefined) {
      // firebase.auth().currentUser.sendEmailVerification();
      props.setActiveStep(1);
    } else {
      setError(err);
    }
    setTimeout(() => {
      setError("");
    }, 6000);
    setLoading(false);
  };

  return (
    <Container id="signin-container" maxWidth="xs">
      <Typography id="signin-text" component="h1" variant="h5">
        Sign up
      </Typography>
      {error && (
        <Snackbar open={true} autoHideDuration={6000}>
          <Alert severity="error">{error}</Alert>
        </Snackbar>
      )}
      <form id="signin-form">
        <TextField
          inputRef={emailRef}
          type="email"
          required
          variant="outlined"
          label="Email Address"
          className="signin-form-input"
        />
        <TextField
          type="password"
          id="password"
          inputRef={passwordRef}
          required
          variant="outlined"
          label="Password"
          className="signin-form-input"
        />
        <TextField
          type="password"
          id="password"
          inputRef={passwordConfirmRef}
          required
          variant="outlined"
          label="Confirm Password"
          className="signin-form-input"
        />
        {!loading ? (
          <Button
            onClick={submitHandler}
            type="submit"
            variant="contained"
            color="primary"
            id="signin-btn"
          >
            Sign up
          </Button>
        ) : (
          <CircularProgress color="primary" />
        )}
        <Link to="/signin" className="small-txt">
          Already have an account? Sign in
        </Link>
      </form>
      <Typography variant="h6" id="or-text"></Typography>
      {/* <div className="google-btn" onClick={signInWithGoogle}>
        <div className="google-icon-wrapper">
          <img
            alt="google"
            className="google-icon"
            src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
          />
        </div>
        <p className="btn-text">
          <b>Sign up with google</b>
        </p>
      </div> */}
    </Container>
  );
};
